module.exports = "https://cdn-skillquest.mathletics.com/app/178/assets/images/204595639e100da339880cb157e14f5d.svg";